import dayjs from 'dayjs';

const formatDateString = (date: string) => {
  return dayjs(date).format('ddd MMM DD YYYY');
};

export default formatDateString;
